import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
    useProTableOt,
    ProTableOt,
    Button,
    DeletePopHover,
    Typography,
    Form,
    message,
    Modal,
    Input
} from "../../ui/ot";
import { Bar, BarChart, CartesianGrid, XAxis, LabelList, YAxis } from "recharts"
import {
    ChartConfig,
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
    ChartLegend, ChartLegendContent
} from "../../ui/chart"

const GroupColumnChart = ({
    //數值類型的key
    chartConfig = {
        desktop: {
            label: "Desktop",
            color: "hsl(var(--chart-1))",
        },
        mobile: {
            label: "Mobile",
            color: "hsl(var(--chart-2))",
        },
    },
    //data
    chartData = [
        { month: "January", desktop: 186, mobile: 80 },
        { month: "February", desktop: 305, mobile: 200 },
        { month: "March", desktop: 237, mobile: 120 },
        { month: "April", desktop: 73, mobile: 190 },
        { month: "May", desktop: 209, mobile: 130 },
        { month: "June", desktop: 214, mobile: 140 },
    ],
    //X 軸顯示的名稱得key
    xDataKeyArr = ["month"],
    //Y 軸顯示的名稱得key
    yDataKeyArr = ["desktop", 'mobile'],
    // showLabel = true
    showLegend = true

}) => {
    return (<Row>
        <Col span={24}>
            <ChartContainer config={chartConfig}

            >
                <BarChart accessibilityLayer data={chartData}>
                    <CartesianGrid vertical={false} />
                    {
                        xDataKeyArr.map((xDataKey) => (
                            <XAxis
                                dataKey={xDataKey}
                                tickLine={false}
                                tickMargin={10}
                                axisLine={false}
                                tickFormatter={(value) => value}
                            />
                        ))
                    }
                    <YAxis domain={[0, 'dataMax + 20']}
                        tickLine={false}
                        axisLine={false}
                        tickMargin={10}
                        allowDecimals={false} />
                    <ChartTooltip
                        cursor={false}
                        content={<ChartTooltipContent indicator="dashed" />}
                    />
                    {
                        yDataKeyArr.map((yDataKey) => (
                            <Bar dataKey={yDataKey} fill={`var(--color-${yDataKey})`} radius={4} />
                        ))
                    }
                    {showLegend && <ChartLegend
                        className=" flex-wrap "
                        content={<ChartLegendContent indicator="line" />} />}
                </BarChart>
            </ChartContainer>
        </Col>
    </Row>)
}
export { GroupColumnChart }
